




































import { Component, Emit, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class Information extends Vue {
  private visible = false; // drawer是否显示
  private title: any = {}; // drawer标题
  private activeName = 'first'; // 被激活的导航项
  private isShow = false; // 是否展开
  private arr: any = [
    {
      id: 1,
      tit: '外部维修工单',
      time: '2021年9月1日',
      content: '您有一个维修工单10210210102012010的维修工单还没您有一个维修工单10210210102012010的维修工单还没',
    },
    {
      id: 2,
      tit: '外部维修工单',
      time: '2021年9月1日',
      content: '您有一个维修工单10210210102012010的维修工单还没您有一个维修工单10210210102012010的维修工单还没',
    },
    {
      id: 3,
      tit: '外部维修工单',
      time: '2021年9月1日',
      content: '您有一个维修工单10210210102012010的维修工单还没您有一个维修工单10210210102012010的维修工单还没',
    },
  ];

  private mounted() {}

  /**
   * @desc 显示drawer
   * @param1 暂无
   * @returns 无
   */

  private async showDrawer() {
    // 显示消息框
    this.visible = true;
    // 消息标题
    this.title = '消息中心';
  }

  /**
   * @desc 关闭drawer
   * @param1 暂无
   * @returns 无
   */

  private handleClose() {
    // 隐藏消息框
    this.visible = false;
  }
  /**
   * @desc 展开收起信息主体内容
   * @param1 index： 内容列表下标
   * @param2 e: 事件源对象
   * @returns 无
   */

  showAll(index: number, e: any): void {
    this.isShow = !this.isShow;
    const conList: any = this.$refs.con;
    if (this.isShow) {
      conList[index].style.whiteSpace = 'pre-wrap';
      conList[index].style.height = '40px';
      e.target.style.transform = 'rotate(90deg)';
    } else {
      conList[index].style.whiteSpace = 'nowrap';
      conList[index].style.height = '20px';
      e.target.style.transform = 'rotate(0deg)';
    }
  }
}
